import { ActionCreator } from "../types/store-types";
import {
    InitLogicActionType,
    LogicActionTypes,
    UpdateLogicRequestActionType,
    UpdateLogicFailureActionType,
    UpdateLogicSuccessActionType,
} from "./types";

export const InitLogic: ActionCreator<InitLogicActionType> = payload => ({
    type: LogicActionTypes.INIT_LOGIC,
    payload,
});

export const updateLogicRequest: ActionCreator<UpdateLogicRequestActionType> = payload => ({
    type: LogicActionTypes.UPDATE_LOGIC_REQUEST,
    payload,
});

export const updateLogicSuccess: ActionCreator<UpdateLogicSuccessActionType> = payload => ({
    type: LogicActionTypes.UPDATE_LOGIC_SUCCESS,
    payload,
});

export const updateLogicFailure: ActionCreator<UpdateLogicFailureActionType> = payload => ({
    type: LogicActionTypes.UPDATE_LOGIC_FAILURE,
    payload,
});
